export const FileUploadHook = {
  mounted() {
    renderInput(this.el, this);
  },

  updated() {
    renderInput(this.el, this);
  },
};

function renderInput(el) {
  const dropArea = el;
  const hoverClass = "bg-default-bg-hover";
  for (const eventName of ["dragenter", "dragover"]) {
    dropArea.addEventListener(eventName, highlight);
  }

  for (const eventName of ["dragleave", "drop"]) {
    dropArea.addEventListener(eventName, unhighlight);
  }

  function highlight() {
    dropArea.classList.add(hoverClass);
  }

  function unhighlight() {
    dropArea.classList.remove(hoverClass);
  }
}
